import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { Form } from '../forms';
export var GlobalForm = /*#__PURE__*/function (_Form) {
  _inherits(GlobalForm, _Form);

  var _super = _createSuper(GlobalForm);

  function GlobalForm(props, id) {
    var _this;

    _classCallCheck(this, GlobalForm);

    _this = _super.call(this, props, id);
    _this.props = props;
    return _this;
  }

  _createClass(GlobalForm, [{
    key: "usageCount",
    get: function get() {
      return this.props.usageCount;
    }
  }, {
    key: "updateCategory",
    value: function updateCategory(category) {
      this.props.category = category;
    }
  }, {
    key: "updateTags",
    value: function updateTags(tags) {
      this.props.tags = tags;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      return Result.ok(new GlobalForm(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "setCategoryTag",
    value: function setCategoryTag(globalForm, categoriesProps, tagsProps) {
      var foundCategory = categoriesProps.find(function (c) {
        return c.id.toString() === globalForm.category.id.toString();
      });
      globalForm.updateCategory(foundCategory);
      var filteredTags = tagsProps.filter(function (t) {
        var _globalForm$tags;

        return (_globalForm$tags = globalForm.tags) === null || _globalForm$tags === void 0 ? void 0 : _globalForm$tags.find(function (g) {
          return g.id.toString() === t.id.toString();
        });
      });
      globalForm.updateTags(filteredTags);
      return globalForm;
    }
  }]);

  return GlobalForm;
}(Form);